<script setup>
import { Handle, Position } from '@vue-flow/core'
import { ref } from 'vue'


</script>

<template>
  <div class="start-node">
    <img src="../../../assets/images/greenFlag.svg" />

    <span>{{$t('start')}}</span>

    <Handle id="output" type="source" :position="Position.Bottom"/>
  </div>
</template>

<style scoped>
.start-node {
  height: 100%;
  width: 100%;
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  background: #fff;
  color: #101828;
  border-radius: 6px;
  box-shadow: none;
  font-size: 16px;
  font-family: 'euclid_regular', sans-serif;
  border: 1px solid #00D68F;
}

.start-node img {
  width: 24px;
  height: 24px;
}

</style>
